<template>
  <div class="page">
    <div class="box">
      <!-- 信息提交区域 -->
      <div class="form-card">
        <div class="form-title">
          <img src="../../../static/infoIcon.png" alt="" class="title-icon" />
          <span>信息提交</span>
          <img
            src="../../../static/infoIcon.png"
            alt=""
            class="title-icon title-icon-right"
          />
        </div>
        <div class="form-desc">
          信息提交后，平台会在24小时内与您联系，帮您服务！
        </div>
        <div class="form-body">
          <input
            type="text"
            class="form-input"
            placeholder="* 您的姓名"
            v-model="formData.name"
          />
          <input
            type="text"
            class="form-input"
            placeholder="* 当前所在城市"
            v-model="formData.city"
          />
          <input
            type="tel"
            class="form-input"
            placeholder="* 手机号码"
            v-model="formData.phone"
            maxlength="11"
          />
        </div>
        <div class="form-btn" @click="submitForm">确认提交</div>
      </div>

      <!-- 提交按钮 -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: "",
      formData: {
        name: "",
        city: "",
        phone: ""
      }
    };
  },
  mounted() {
    this.initWeChatJSSDK();
    if (this.$route.query.token) {
      localStorage.setItem("TOKEN", this.$route.query.token);
      this.token = this.$route.query.token;
    } else {
      // 非小程序环境，调用原生方法获取用户信息
      // 小程序环境已在小程序端判断登录状态，未登录不会进入此页面
      this.clickAskari();
      window.setUserInfo = val => {
        try {
          let obj = JSON.parse(val);
          let token = obj.loginUserVO.accessToken;
          localStorage.setItem("TOKEN", token);
        } catch (error) {
          console.error("请求失败:", error);
        }
      };
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      if (!this.formData.name) {
        return this.$message({ message: "请输入姓名", type: "warning" });
      }
      if (!this.formData.city) {
        return this.$message({ message: "请输入城市", type: "warning" });
      }
      if (!this.formData.phone || !/^1\d{10}$/.test(this.formData.phone)) {
        return this.$message({
          message: "请输入正确的手机号码",
          type: "warning"
        });
      }
      this.$axios
        .post(`/mapi/api/veteran/submit`, {
          name: this.formData.name,
          city: this.formData.city,
          phone: this.formData.phone
        })
        .then(({ data }) => {
          this.$message({ message: "提交成功", type: "success" });
          if (this.detectMobileOS() == "WeChatMiniProgram") {
            if (window.wx && window.wx.miniProgram) {
              setTimeout(() => {
                window.wx.miniProgram.switchTab({
                  url: "/pages/indexList/indexList"
                });
              }, 3000);
            }
          } else if (this.detectMobileOS() == "Android") {
            setTimeout(() => {
              this.callAndroid2();
            }, 3000);
          } else {
            setTimeout(() => {
              this.callIOS2();
            }, 3000);
          }
        })
        .catch(err => {});
    },
    // 初始化微信 JSSDK
    initWeChatJSSDK() {
      console.log("initWeChatJSSDK called");
      if (window.wx) {
        wx.ready(() => {
          console.log("wx.ready called");
          // 分享给朋友
          wx.updateAppMessageShareData({
            title: "好运两天一开，好活儿随时等你来",
            desc: "注册咖德安保App或小程序，参与抽奖赢现金红包！",
            link: window.location.href,
            imgUrl: this.imgList.shareImg || "",
            success: () => {
              console.log("分享给朋友成功");
            }
          });
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: "好运两天一开，好活儿随时等你来",
            link: window.location.href,
            imgUrl: this.imgList.shareImg || "",
            success: () => {
              console.log("分享到朋友圈成功");
            }
          });
          // 开启分享菜单
          wx.showShareMenu({
            withShareTicket: true,
            menus: ["shareAppMessage", "shareTimeline"]
          });
        });
        wx.error(res => {
          console.error("wx.error:", res);
        });
      } else {
        console.log("wx not available (非小程序环境)");
      }
    },
    clickAskari() {
      if (this.detectMobileOS() == "IOS") {
        // 检查 window.webkit 是否存在（只有在 iOS App 的 WebView 中才有）
        if (window.webkit && window.webkit.messageHandlers) {
          try {
            window.webkit.messageHandlers["getUserInfo"].postMessage(
              "H5获取用户信息"
            );
          } catch (error) {
            console.error("请求失败:", error);
          }
        } else {
          console.log(
            "window.webkit.messageHandlers 不可用，当前可能不是 iOS App 环境"
          );
        }
      } else if (this.detectMobileOS() == "WeChatMiniProgram") {
        this.callWeChatMiniProgram("getUserInfo");
      } else {
        // Android 环境也需要检查 Android 对象是否存在
        if (typeof Android !== "undefined" && Android.getUserInfo) {
          Android.getUserInfo("来自 JavaScript 的消息");
        } else {
          console.log("Android 对象不可用，当前可能不是 Android App 环境");
        }
      }
    },
    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log("UserAgent:", userAgent);

      // Windows Phone必须放在前面，因为它的UA也包含"Android"
      if (/windows phone/i.test(userAgent)) return "Windows Phone";

      // 微信小程序检测（必须在普通浏览器检测之前）
      if (/MicroMessenger/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
        console.log("Detected: WeChatMiniProgram");
        return "WeChatMiniProgram";
      }

      if (/android/i.test(userAgent)) {
        console.log("Detected: Android");
        return "Android";
      }

      // iOS检测
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        console.log("Detected: IOS");
        return "IOS";
      }
      console.log("Detected: Unknown");
      return "Unknown";
    },
    // 调用 Android 原生跳转首页方法
    callAndroid2() {
      Android.returnToHome("来自 JavaScript 的消息");
    },
    // 调用 iOS 原生跳转首页方法
    callIOS2() {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers["returnToHome"]
      ) {
        // 调用原生方法
        window.webkit.messageHandlers["returnToHome"].postMessage("H5回调");
      }
    }
  }
};
</script>
<style scoped>
body {
  padding: 0 0;
  margin: 0 0;
}

.model {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}
.dialog {
  width: 300px;
  /* height: 200px; */
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  padding: 10px 0;
  box-sizing: border-box;
  text-align: center;
}
.diaTitle {
  font-family: Lenovo, Lenovo;
  font-weight: normal;
  font-size: 18px;
  color: #000;
  line-height: 38px;
  text-align: center;
  font-style: normal;
}
.diaContent {
  padding: 15px 30px;
  box-sizing: border-box;
  border-bottom: #e5e5e5 solid 1px;
}
.diaBtn {
  display: inline-block;
  width: 50%;
  height: 40px;
  line-height: 40px;
  color: #285052;
  font-size: 16px;
  box-sizing: border-box;
  cursor: pointer;
}
.page {
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.page::-webkit-scrollbar {
  display: none;
}

.box {
  width: 100%;
  height: 1000px;
  box-sizing: border-box;
  background-image: url("https://baoanlailou-online.oss-cn-beijing.aliyuncs.com/miniapp/veteranBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
  box-sizing: border-box;
  position: relative;
}

/* 服务说明卡片 */
.service-card {
  width: 90%;
  max-width: 400px;
  background: rgba(255, 245, 230, 0.95);
  border-radius: 12px;
  padding: 16px 20px;
  box-sizing: border-box;
}

.service-text {
  font-size: 13px;
  color: #333;
  line-height: 1.8;
}

/* 专属权益标题 */
.benefit-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  max-width: 400px;
  margin-bottom: 16px;
}

.benefit-line {
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.5);
  max-width: 60px;
}

.benefit-title {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin: 0 12px;
  white-space: nowrap;
}

/* 权益卡片 */
.benefit-item {
  width: 90%;
  max-width: 400px;
  background: rgba(255, 245, 230, 0.95);
  border-radius: 12px;
  padding: 14px 16px;
  box-sizing: border-box;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  border: 1px dashed rgba(200, 150, 80, 0.5);
}

.benefit-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #e53935, #c62828);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
}

.benefit-text {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* 表单卡片 */
.form-card {
  position: absolute;
  bottom: 20px;
  left: 5%;
  width: 90%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
}

/* 标题区域 */
.form-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.form-title span {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0 12px;
}

.title-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.title-icon-right {
  transform: scaleX(-1);
}

/* 说明文字 */
.form-desc {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-bottom: 20px;
}

/* 表单区域 */
.form-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-input {
  width: 100%;
  height: 37px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  outline: none;
  transition: border-color 0.3s;
}

.form-input:focus {
  border-color: #ff6b35;
}

.form-input::placeholder {
  color: #999;
}

/* 提交按钮 */
.form-btn {
  width: 100%;
  max-width: 400px;
  height: 40px;
  background: linear-gradient(90deg, #ff6b35, #ffa05a);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s;
  margin-top: 20px;
  flex-shrink: 0;
}

.form-btn:active {
  opacity: 0.85;
}
</style>



// WEBPACK FOOTER //
// src/view/veteran/veteran.vue